import React, { Component } from 'react'
import SystemLabelMasterCollection from 'collections/system_label_master_collection'

class SelectTransmission extends Component {

  handleChange = (e) => {
    this.props.actions.changeSelectTransmission({
      selectTransmission: e.target.value,
    })
  }

  render() {
    const { payload } = this.props.systemLabelMastersApi
    if (!payload) {
      return null
    }
    const systemLabelMasterCollection = new SystemLabelMasterCollection(payload)
    const { selectTransmission } = this.props
    return (
      <div className='searchArea__item'>
        <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.LIST_SEARCH.TRANSMISSION}</h3>
        <p className='radio radio-3 searchArea__item__inner'>
          <input
            className='radio'
            checked={selectTransmission == ''}
            type='radio'
            name='select_transmission'
            value=''
            id='transmission_all'
            onChange={this.handleChange}
          />
          <label htmlFor='transmission_all'>{TRUCKERS.LANG.ITEM.LIST_SEARCH.ALL}</label>
          {
            systemLabelMasterCollection.getValueList('item', 'select_transmission').map(i => {
              return (
                <React.Fragment key={i.get('label_key')}>
                  <input
                    className='radio'
                    checked={i.get('label_key') == selectTransmission}
                    type='radio'
                    name='select_transmission'
                    value={i.get('label_key')}
                    id={i.get('label_key')}
                    onChange={this.handleChange}
                  />
                  <label htmlFor={i.get('label_key')}>{i.getValueI18n()}</label>
                </React.Fragment>
              )
            })
          }
        </p>
      </div>
    )
  }
}

export default SelectTransmission
